module.exports = __webpack_public_path__ + "img/app_sub_icon.82f143be.svg";